import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularMaterialModule } from '../../material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MultiselectComponent } from './multiselect.component';

@NgModule({
    declarations: [MultiselectComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMaterialModule,
    ],
    exports: [
        MultiselectComponent,
    ]
})
export class MultiselectkModule { }
